import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Subresellers from "components/Panel/Admin/Subresellers";
import Button from "components/Button";
import { Link } from "react-router-dom"
import Pagination from "components/Pagination";

import { getSubresellers } from "redux/admin/users/usersSlice";

const SubresellersContainer = () => {
  const dispatch = useDispatch();
  const { data } = useSelector(state => state.adminUsers.subresellers);
  const { total, pages, page, per_page } = useSelector(state => state.adminUsers.subresellers);
  useEffect(() => {
    dispatch(getSubresellers({ page: 1, per_page: 15, show_inactive: true }))
  }, [dispatch])

  const handlePageChange = (newPage) => {
    dispatch(getSubresellers({ page: newPage, per_page: 15, show_inactive: true }))
  };
  return (
    <div className="bg-black min-h-screen">
      <div className="p-4 flex items-center justify-between">
        <h2 className="text-xl font-semibold text-white-100">Alt Bayi Listesi</h2>
        <Link to="/admin/subresellers/create"> <Button size="small">Alt Bayi Ekle</Button></Link>
      </div>
      <Subresellers data={data} />
      <Pagination currentPage={page} totalPages={pages} onPageChange={handlePageChange} />
    </div>
  );
};

export default SubresellersContainer;
